<template>
    <div class="wrap">
        <div class="containter">
            <type-menu ref="typeMenu" no-edit @onChangeMenu="onChangeMenu"></type-menu>
            <div class="content" v-loading="loading">
                <div class="c-header">
                    <div class="header-group-left">
                    </div>
                    <div class="header-group-right">
                        <div>
                            <el-input placeholder="搜索嘉宾姓名、公司或职位" v-model="query.keyword" class="input-with-select" size="mini">
                                <template #append>
                                    <el-button icon="el-icon-search" @click="getList"></el-button>
                                </template>
                            </el-input>
                        </div>
                    </div>
                </div>

                <div class="c-main">
                    <div class="overflow-container">
                        <el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column prop="name" label="姓名" width="100" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="头像" width="80" align="center">
                                <template v-slot="scope">
                                    <el-avatar 
                                        :size="40" 
                                        :src="scope.row.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" 
                                        fit="cover">
                                    </el-avatar>
                                </template>
                            </el-table-column>
                            <el-table-column prop="company" label="公司" min-width="120" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="position" label="职务" min-width="120" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="分类" width="100" align="center">
                                <template v-slot="scope">
                                    <el-tag size="small" v-if="scope.row.categoryName">{{ scope.row.categoryName }}</el-tag>
                                    <span v-else class="no-group">未分类</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page">
                        <el-pagination 
                            class="" 
                            @current-change="handleCurrentChange" 
                            :current-page="query.page"
                            :page-sizes="[10, 20, 50, 100]" 
                            :page-size="query.pageSize"
                            @size-change="handleSizeChange"
                            layout="total, prev, pager, next, jumper" 
                            :total="query.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getGuestList, getGuestCategories } from "@/api/guest"
import TypeMenu from "@/pages/mall/components/TypeMenu.vue"

export default {
    components: {
        TypeMenu,
    },
    data() {
        return {
            loading: true,
            list: [],
            category: "",
            subCategory: void 0,
            categoryMap: {}, // 用于存储分类ID到名称的映射
            query: {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            },
        };
    },
    mounted() {
        this.initList();
    },
    methods: {
        onChangeMenu({ id, cid }) {
            this.category = id;
            this.subCategory = cid;
            this.query = {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            };
            this.getList();
        },
        
        async initList() {
            // 获取分类信息用于显示
            await this.fetchCategories();
            // 获取嘉宾列表
            await this.getList();
        },

        async fetchCategories() {
            try {
                const response = await getGuestCategories();
                if (response.status === '10000') {
                    const categories = response.data.categories || [];
                    // 创建分组ID到名称的映射
                    this.categoryMap = {};
                    categories.forEach(category => {
                        this.categoryMap[category._id] = category.name;
                    });
                }
            } catch (error) {
                console.error('获取分组列表失败:', error);
            }
        },

        async getList() {
            try {
                this.loading = true;
                const { page, pageSize } = this.query;
                const params = {
                    page: page,
                    pageSize: pageSize,
                    search: this.query.keyword
                };
                
                // 添加分类参数
                if (this.category) {
                    params.category = this.category;
                }
                
                // 添加子分类参数
                if (this.subCategory) {
                    params.subCategory = this.subCategory;
                }
                
                const response = await getGuestList(params);
                
                if (response.status === '10000') {
                    // 处理嘉宾数据，添加分类名称
                    this.list = response.data.map(guest => {
                        const categoryId = guest.category;
                        if (categoryId && this.categoryMap[categoryId]) {
                            guest.categoryName = this.categoryMap[categoryId];
                        }
                        return guest;
                    });
                    
                    this.query.total = response.pagination.total;
                } else {
                    throw new Error(response.message || '获取嘉宾列表失败');
                }
            } catch (error) {
                this.$message.error(error.message || '获取嘉宾数据失败');
            } finally {
                this.loading = false;
            }
        },

        handleCurrentChange(page) {
            this.query.page = page;
            this.getList();
        },
        
        handleSizeChange(size) {
            this.query.pageSize = size;
            this.query.page = 1;
            this.getList();
        },

        handleSelectionChange(val) {
            // 转换数据格式并发送给父组件
            const guestData = val.map((item) => {
                return {
                    id: item._id,
                    name: item.name,
                    avatar: item.avatar,
                    company: item.company,
                    position: item.position,
                    bio: item.bio,
                    email: item.email,
                    phone: item.phone,
                    category: item.category
                }
            });
            this.$emit('onChangeSelection', guestData);
        }
    },
};
</script>

<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 500px;

    .containter {
        width: 100%;
        height: 100%;
        display: flex;

        .content {
            flex: 1;
            height: 100%;
            background-color: #fff;
            border-radius: 4px;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .c-header {
                height: 50px;
                padding: 0 20px;
                background-color: #f5f7fa;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .header-group-left {
                    display: flex;
                    align-items: center;
                }

                .header-group-right {
                    display: flex;
                    align-items: center;
                }
            }

            .c-main {
                flex: 1;
                display: flex;
                flex-direction: column;
                padding: 20px;
                overflow: hidden;

                .overflow-container {
                    flex: 1;
                    overflow: auto;
                }

                .page {
                    margin-top: 15px;
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
    }
}

.no-group {
    color: #909399;
    font-size: 13px;
}
</style> 